// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6671) return "static/chunks/6671-58f2197d65efdbfa.js";
	if (chunkId === 5452) return "static/chunks/5452-53fd189ebbc082bb.js";
	if (chunkId === 9771) return "static/chunks/9771-02caf5fc165e1000.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"106":"d4fc425d7f64f924","167":"fd1051145c0f055b","449":"ccb07367513700df","1418":"50cae324c2b2664b","1719":"633062974a5699df","3327":"c633a72c605a7d74","4226":"8c00628cfd616e3e","6004":"05deecd6f825c321","7592":"d2b0507607d82b69","8962":"85974f2ae5d3d192"}[chunkId] + ".js";
};